<script>
    import ElementTypeIcon from '../../Element/ElementTypeIcon.svelte';
    import ElementStatus from './ElementStatus.svelte';
    import StatusBadge from '../../common/StatusBadge.svelte';
    import ListItemNameControl from './ListItemNameControl.svelte';
    import {WORK_SEQUENCE_API} from '../../../apiUrls.js';
    import {submit} from '../../../utils.js';
    import ContextualText from '../ElementView/ContextualText.svelte';

    import {editable} from '../../Workspaces/workspacesStore';

    export let col = '';
    export let row = {};
    export let options = null;
    export let sequence_index = 0;

    let componentClass = row.type ? 'element' : 'worksequence';

    async function updateWorkSequenceName(ws) {
        const url = `${WORK_SEQUENCE_API}${ws.id}/update_name/`;

        await submit(url, 'post', {name: ws.name});
    }

</script>

<style>
    .element :global(.badge) {
        font-size: 12px;
    }

    .short-text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .invalid {
        display: flex;
    }
</style>


<div class="short-text {componentClass}" title={row.name}>
    <ElementTypeIcon type={row.type}/>
    {#if componentClass === 'element'}

        {#if $editable}
            <ElementStatus versions={row.versions} expired={row.expired}
                           status={row.versions && row.versions.length > 0? row.versions[0].status : row.status}/>
        {:else}
            <ElementStatus versions={row.versions} expired={row.expired} status={row.status}/>
        {/if}
        <span class="name">{row[col]}</span>
        {#if row.suffix}
            <ContextualText>{row.suffix}</ContextualText>
        {/if}
    {:else if componentClass === 'worksequence'}
        <div class="invalid">
            <StatusBadge status={row.draft ? 'Draft' : null}/>
           <ListItemNameControl editable={$editable} {row} {col} save={updateWorkSequenceName}/>
        </div>
    {/if}
</div>
